import 'lib/toolkit/page_nav.js.coffee';
import 'lib/toolkit/behaviors/array_field.js.coffee';
import 'lib/toolkit/behaviors/buttons.js.coffee';
import 'lib/toolkit/behaviors/collapsible.js.coffee';
import 'lib/toolkit/behaviors/dropdowns.js.coffee';
import 'lib/toolkit/behaviors/modals.js.coffee';
import 'lib/toolkit/behaviors/textarea.js.coffee';
import 'lib/toolkit/behaviors/tooltips.js.coffee';
import 'lib/toolkit/behaviors/widget.js.coffee';



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/toolkit.js.coffee